"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withId = /*#__PURE__*/ (0, vue_2.withScopeId)("data-v-bdc8b958");
(0, vue_2.pushScopeId)("data-v-bdc8b958");
var _hoisted_1 = { style: { "position": "absolute", "inset": "8px", "display": "flex" } };
var _hoisted_2 = { style: { "flex": "1 1 auto", "position": "relative" } };
var _hoisted_3 = {
    key: 0,
    style: { "position": "absolute", "inset": "0", "display": "flex", "align-items": "center", "justify-content": "center" }
};
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" 查询 ");
var _hoisted_5 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" 查询 ");
(0, vue_2.popScopeId)();
var element_plus_1 = require("element-plus");
var BureauTagSelector_vue_1 = require("./BureauTagSelector.vue");
var vue_3 = require("vue");
var bureau_1 = require("../../napis/bureau");
var time_1 = require("../../utils/time");
var echarts = require("echarts");
var moment = require("moment");
exports.default = (0, vue_1.defineComponent)({
    expose: [],
    setup: function (__props) {
        function generateTimePair(range) {
            if (range === void 0) { range = 6; }
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * range);
            return [start, end];
        }
        var timePairGenerator = function (range) { return function () { return generateTimePair(range); }; };
        var monthRangeShortcuts = [
            {
                text: '最近1年',
                value: timePairGenerator(364),
            },
            {
                text: '最近2年',
                value: timePairGenerator(729),
            },
        ];
        var dateRangeShortcuts = __spreadArray([
            {
                text: '最近7天',
                value: timePairGenerator(6),
            },
            {
                text: '最近30天',
                value: timePairGenerator(29),
            },
            {
                text: '最近90天',
                value: timePairGenerator(89),
            }
        ], monthRangeShortcuts, true);
        var BY_MONTH = "ByMonth";
        var dateRange = (0, vue_3.ref)(generateTimePair(364));
        var tags = (0, vue_3.ref)();
        var data = (0, vue_3.ref)([]);
        var loading = (0, vue_3.ref)(false);
        var selectedTab = (0, vue_3.ref)(BY_MONTH);
        var accumulated = (0, vue_3.ref)(false);
        var isByMonth = (0, vue_3.computed)(function () { return selectedTab.value === BY_MONTH; });
        function loadData() {
            return __awaiter(this, void 0, void 0, function () {
                var f, _a, s, e, list;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            loading.value = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 3, 4]);
                            f = isByMonth.value ? time_1.convertConventionalToNormalMonth : time_1.convertConventionalToNormal;
                            _a = f(dateRange.value[0], dateRange.value[1]), s = _a[0], e = _a[1];
                            return [4 /*yield*/, (0, bureau_1.getActivatedAccountHistoricalStats)(s, e, tags.value, [], accumulated.value ? 0 : 1)];
                        case 2:
                            list = _b.sent();
                            data.value = list;
                            return [3 /*break*/, 4];
                        case 3:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)([tags], function (_a, _b) {
            var n = _a[0];
            var o = _b[0];
            if (!o && Boolean(n))
                loadData();
        });
        var echartContainer = (0, vue_3.ref)();
        var chart = null;
        function fetchChartInstance() {
            if (!chart) {
                chart = echarts.init(echartContainer.value);
            }
            return chart;
        }
        function draw() {
            if (data.value.length < 1)
                return;
            function isNotEmpty(it) {
                if (!it)
                    return false;
                return it.active_student_amount > 0 && it.active_teacher_amount > 0;
            }
            var d = data.value;
            if (isByMonth.value) {
                var map = new Map();
                for (var i = d.length - 1; i >= 0; i--) {
                    var it = d[i];
                    var date = moment(it.cdate).format("YYYY-MM");
                    if (isNotEmpty(map.get(date)))
                        continue;
                    map.set(date, it);
                }
                d = Array.from(map.values()).reverse();
            }
            var chart = fetchChartInstance();
            chart.setOption({
                title: {
                    text: "\u88AB\u6FC0\u6D3B\u8D26\u6237\u5386\u53F2\u7EDF\u8BA1\uFF08".concat(isByMonth.value ? "按月" : "按日", "\uFF09"),
                },
                tooltip: {
                    trigger: 'axis',
                    position: function (pt) {
                        return [pt[0], '10%'];
                    }
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center'
                },
                xAxis: {
                    data: d.map(function (it) { return moment(it.cdate).format(isByMonth.value ? "YYYY-MM" : "YYYY-MM-DD"); })
                },
                yAxis: {},
                series: [
                    { type: "line", smooth: true, name: "学生", data: d.map(function (it) { return it.active_student_amount; }) },
                    { type: "line", smooth: true, name: "教师", data: d.map(function (it) { return it.active_teacher_amount; }) },
                ]
            });
            chart.resize();
        }
        (0, vue_3.watch)([data, selectedTab], function () { return draw(); });
        (0, vue_3.onMounted)(function () {
            window.addEventListener("resize", draw);
        });
        (0, vue_3.onBeforeUnmount)(function () { return window.removeEventListener("resize", draw); });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)("div", {
                        ref: echartContainer,
                        class: "echart-container",
                        style: { visibility: loading.value ? 'hidden' : 'visible' }
                    }, null, 4),
                    (loading.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)("div", _hoisted_3, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElProgress), {
                                indeterminate: true,
                                percentage: 100,
                                style: { "width": "50%" },
                                "show-text": false
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDivider), {
                    direction: "vertical",
                    style: { "height": "100%" }
                }),
                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElTabs), {
                    modelValue: selectedTab.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return (selectedTab.value = $event); }),
                    style: { "min-width": "380px" }
                }, {
                    default: _withId(function () { return [
                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElTabPane), {
                            label: "按月统计",
                            name: BY_MONTH
                        }, {
                            default: _withId(function () { return [
                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElForm), {
                                    "label-width": "80px",
                                    size: "small"
                                }, {
                                    default: _withId(function () { return [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "机构标签" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)(BureauTagSelector_vue_1.default, {
                                                    modelValue: tags.value,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (tags.value = $event); }),
                                                    placeholder: "全部"
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "累计全部" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElSwitch), {
                                                    modelValue: accumulated.value,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (accumulated.value = $event); })
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "月份" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDatePicker), {
                                                    modelValue: dateRange.value,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (dateRange.value = $event); }),
                                                    type: "monthrange",
                                                    "unlink-panels": "",
                                                    "range-separator": "至",
                                                    "start-placeholder": "开始月份",
                                                    "end-placeholder": "结束月份",
                                                    shortcuts: monthRangeShortcuts,
                                                    clearable: false
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), null, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElButton), {
                                                    type: "primary",
                                                    loading: loading.value,
                                                    onClick: loadData
                                                }, {
                                                    default: _withId(function () { return [
                                                        _hoisted_4
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["loading"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElTabPane), {
                            label: "按日统计",
                            name: "ByDate"
                        }, {
                            default: _withId(function () { return [
                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElForm), {
                                    "label-width": "80px",
                                    size: "small"
                                }, {
                                    default: _withId(function () { return [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "机构标签" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)(BureauTagSelector_vue_1.default, {
                                                    modelValue: tags.value,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (tags.value = $event); }),
                                                    placeholder: "全部"
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "累计全部" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElSwitch), {
                                                    modelValue: accumulated.value,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return (accumulated.value = $event); })
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "日期" }, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDatePicker), {
                                                    modelValue: dateRange.value,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return (dateRange.value = $event); }),
                                                    type: "daterange",
                                                    "unlink-panels": "",
                                                    "range-separator": "至",
                                                    "start-placeholder": "开始时间",
                                                    "end-placeholder": "结束时间",
                                                    shortcuts: dateRangeShortcuts,
                                                    clearable: false
                                                }, null, 8, ["modelValue"])
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), null, {
                                            default: _withId(function () { return [
                                                (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElButton), {
                                                    type: "primary",
                                                    loading: loading.value,
                                                    onClick: loadData
                                                }, {
                                                    default: _withId(function () { return [
                                                        _hoisted_5
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["loading"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
